import { Box, Button, Stack } from '@mui/material';
import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { useForm } from 'react-hook-form';
import AuthSelect from '../../../components/AuthController/AuthSelect';
import AuthInput from '../../../components/AuthController/AuthInput';
import { useDispatch, useSelector } from 'react-redux';
import { colorPicker } from '../../../../constants';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMessage } from '../../../../base/MessageProvider';
import { Bars } from 'react-loader-spinner';
import clsx from 'clsx';
import ReactTextInput from '../../../../components/ControllerComponent/ReactTextInput';
import ReactSelect from '../../../../components/ControllerComponent/ReactSelect';
import { addFolder, getFolderList, updateFolder } from '../../../actions/folder';

const validateSchema = Yup.object().shape({
    name: Yup.string().required("Folder name cannot be empty"),
    colour: Yup.string().required("Please select color"),
})

const FolderForm = forwardRef(({ metadata, onClose }, ref) => {

    useImperativeHandle(ref, () => ({
        onSubmit
    }));

    const alert = useMessage();
    const dispatch = useDispatch();

    const currentFolder = useSelector((state) => state.recruiterFolderReducer?.currentFolder);
    const loading = useSelector((state) => state.recruiterFolderReducer?.loading);

    const {
        control, handleSubmit, setValue,
        watch, formState: { errors }
    } = useForm({
        resolver: yupResolver(validateSchema),
        defaultValues: { name: '', colour: 'F8C630' }
    });

    useEffect(() => {
        setValue('name', metadata?.name ?? '');
        setValue('colour', metadata?.colour ?? 'F8C630')
    }, [metadata]);

    const successCallback = (res) => {
        dispatch(getFolderList({ folderId: currentFolder?.id }));
        alert.showSuccess(res?.message);
        onClose();
    }

    const errorCallback = (error) => {
        alert.showError(error?.message ?? "Something went wrong!!");
    }

    const addHandler = async (data) => {
        const request = {
            name: data.name,
            colour: data.colour,
            parentId: currentFolder?.id
        };

        dispatch(addFolder(request, successCallback, errorCallback));
    }

    const updateHandler = async (data) => {
        const request = {
            id: metadata?.id,
            name: data.name,
            colour: data.colour,
            parentId: currentFolder?.id
        };

        dispatch(updateFolder(request, successCallback, errorCallback));
    }

    const onSubmit = (data) => {
        if (metadata) updateHandler(data);
        else addHandler(data);
    }


    return (
        <Box className="w-[90%] my-2 px-5">
            <Stack className="w-full" spacing={2} my={1}>
                <ReactTextInput
                    hookFormControl={control}
                    formLabel="Folder Name*"
                    varName="name"
                    key={'name'}
                    placeholder='Folder name' 
                    errorMessage={errors?.name?.message}
                />
                <ReactSelect
                    hookFormControl={control}
                    formLabel="Folder Color*"
                    varName="colour"
                    options={colorPicker}
                    placeholder='Select color' 
                    errorMessage={errors?.colour?.message}
                />
                <Button onClick={handleSubmit(onSubmit)} disabled={loading} className={clsx("bg-[#2F80ED] flex gap-3 justify-center text-[#FFF] w-full rounded-lg font-['Poppins-Medium'] font-[500]", { "bg-opacity-70": loading })}>
                    Submit
                    <Bars
                        height="20"
                        width={'20'}
                        color="#FFFFFF"
                        ariaLabel="bars-loading"
                        visible={loading}
                    />
                </Button>
            </Stack>
        </Box>
    );
});

export default FolderForm;